// extracted by mini-css-extract-plugin
export var divider = "_f1-7";
export var itemsToggle = "_f1-8";
export var mergeModal = "_f1-1";
export var optionCard = "_f1-4";
export var radioGroup = "_f1-6";
export var radioOption = "_f1-0";
export var selected = "_f1-5";
export var shipmentOptions = "_f1-2";
export var tableOptions = "_f1-3";